import Slider from "react-slick";
const TopSellers = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 787,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  };

  const topSellers = [
    {
      image: "../../assets/images/topseller/topseller.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/topseller.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img2.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img3.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img4.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img5.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img6.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img7.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img8.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img9.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
    {
      image: "../../assets/images/topseller/img10.png",
      title: "Cyber Punk",
      balance: "101.35 SOL",
    },
  ];

  return (
    <Slider {...settings}>
      {topSellers.map((item, index) => {
        return (
          <div key={index}>
            <div className="top-sellers-single-wrap">
              <div className="for-verified">
                <img className="item-img" src={item.image} />
                <div className="ver-icon-wrap">
                  <img
                    className="verified-img sell"
                    src="../../../assets/images/topseller/verified-icon.png"
                  />
                </div>
              </div>
              <h3 className="topshop-tit">{item.title}</h3>
              <div className="d-flex align-items-center p">
                <h6 className="101.35 eth-balance">{item.balance}</h6>
              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  );
};
export default TopSellers;
